// extracted by mini-css-extract-plugin
export default {"productGrid":"P2-z","centerLink":"Q2-z","productSection":"R2-z","item":"S2-z","ctaButton":"T2-z"};